const PageHeader = ({ title, description, icon: Icon, actions, children }) => {
  const actionsContent = actions ?? children;

  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
      <div className="min-w-0 space-y-2">
        <div className="flex items-center gap-3">
          {Icon ? (
            <Icon size={28} className="hidden shrink-0 text-primary sm:block" />
          ) : null}
          <h2 className="text-lg font-medium text-primary sm:text-xl">
            {title}
          </h2>
        </div>
        {description ? (
          <p className="whitespace-pre-wrap text-sm text-muted-foreground sm:text-base">
            {description}
          </p>
        ) : null}
      </div>
      {actionsContent ? (
        <div className="flex w-full flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center md:w-auto md:justify-end">
          {actionsContent}
        </div>
      ) : null}
    </div>
  );
};

export default PageHeader;
